import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLanguage } from '@ipc/ipc-core';
import { useHistory, useLocation } from 'react-router-dom';
import { getUserRole } from '../../../common/user/redux/selectors/UserSelectors';
import ListTableContainer from '../../../common/list-table/containers/ListTableContainer';
import { getBlockRouting, getUserConfirmed } from '../../../common/redux/selectors/redirectSelector';
import { triggerConfirmationDialogAction, triggerRedirect } from '../../../common/redux/actions/redirectActions';
import { setTableActiveFilter } from '../../../common/list-table/actions/ListTableActions';

function MrdAdministrationPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

MrdAdministrationPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const useTabStyles = makeStyles({
  root: {
    justifyContent: 'center',
  },
  scroller: {
    flexGrow: '0',
  },
});

function SimpleTabs(props) {
  const classes = useStyles();
  const tabClasses = useTabStyles();
  const [value, setValue] = React.useState('/');
  const [blockedValue, blockValue] = React.useState('');
  const [, language] = useLanguage();
  const history = useHistory();
  const location = useLocation();

  const {
    userRole,
    routeBlocker,
    setAlert,
    resetConfirmation,
    isUserConfirmed,
    withURL,
    setTableFilter,
  } = props;

  const updateValue = (newValue) => {
    const { pathname } = location;
    setValue(newValue);
    if (!pathname.endsWith(newValue)) {
      history.push(language(`/administration${newValue}`));
    }
  };

  useEffect(() => {
    if (!routeBlocker && blockedValue !== '' && isUserConfirmed) {
      updateValue(blockedValue);
      resetConfirmation(false);
      blockValue('');
    }
  }, [isUserConfirmed]);

  useEffect(() => {
    if (withURL && withURL !== value) {
      updateValue(withURL);
    }
  }, [withURL]);

  const handleChange = (event, newValue) => {
    if (!routeBlocker) {
      updateValue(newValue);
      setTableFilter();
    } else {
      blockValue(newValue);
      setAlert(true);
    }
  };

  const userRoles = ['IPC_ADMIN', 'IPC_VIEWER', 'OPER_ADMIN', 'OPER_VIEWER'];
  const onlyIpcUserRoles = ['IPC_ADMIN', 'IPC_VIEWER'];

  const isVisibleUserRole = userRoles.includes(userRole);
  const isVisibleIpcUserRole = onlyIpcUserRoles.includes(userRole);
  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary">
        <Tabs classes={{ root: tabClasses.root, scroller: tabClasses.scroller }} value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="on">
          <Tab label="" value="/" className="hidden-tab" />
          {isVisibleUserRole && <Tab label="Device Information" textColor="secondary" {...a11yProps(0)} value="/device-info" />}
          {isVisibleUserRole && <Tab label="Device Settings" {...a11yProps(1)} value="/device-settings" />}
          {isVisibleUserRole && <Tab label="Flights" {...a11yProps(2)} value="/flights" />}
          {isVisibleUserRole && <Tab label="Handlers" {...a11yProps(3)} value="/handlers" />}
          {isVisibleUserRole && <Tab label="Data sharing" {...a11yProps(4)} value="/data-sharing" />}
          {isVisibleUserRole && <Tab label="Contacts" {...a11yProps(5)} value="/mrd-contact" />}
          {isVisibleUserRole && <Tab label="MRD APP translation" {...a11yProps(6)} value="/mrd-app-translation" />}
          {isVisibleIpcUserRole && <Tab label="Notification service" {...a11yProps(7)} value="/notification-service" />}
          {isVisibleIpcUserRole && <Tab label="IMPC mapping" {...a11yProps(8)} value="/impc-mapping" />}
        </Tabs>
      </AppBar>
      <MrdAdministrationPanel value={value} index="/device-info">
        {isVisibleUserRole && <ListTableContainer tableId="MRD" />}
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/device-settings">
        <ListTableContainer tableId="MRD_SETTINGS" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/flights">
        <ListTableContainer tableId="MRD_ADMINISTRATION_FLIGHTS" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/handlers">
        <ListTableContainer tableId="HANDLERS_BY_MRD_DEVICE" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/data-sharing">
        <ListTableContainer tableId="DATA_SHARING_VIEW" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/mrd-contact">
        <ListTableContainer tableId="MRD_CONTACTS_PAGE" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/mrd-app-translation">
        <ListTableContainer tableId="MRD_APP_TRANSLATIONS" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/notification-service">
        <ListTableContainer tableId="NOTIFICATION_SERVICE_THRESHOLD" />
      </MrdAdministrationPanel>
      <MrdAdministrationPanel value={value} index="/impc-mapping">
        <ListTableContainer tableId="MRD_DENEST_IMPC_MAPPING" />
      </MrdAdministrationPanel>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userRole: getUserRole(state),
    routeBlocker: getBlockRouting(state),
    isUserConfirmed: getUserConfirmed(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setAlert: triggerConfirmationDialogAction,
  resetConfirmation: triggerRedirect,
  setTableFilter: setTableActiveFilter,
}, dispatch);

SimpleTabs.propTypes = {
  userRole: PropTypes.string,
  routeBlocker: PropTypes.bool,
  setAlert: PropTypes.func,
  isUserConfirmed: PropTypes.bool,
  resetConfirmation: PropTypes.func,
  withURL: PropTypes.string,
  setTableFilter: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimpleTabs);
